// extracted by mini-css-extract-plugin
module.exports = {"Intro":"Fees_Intro__2u6hi","container1":"Fees_container1__1pTxP","focusLine":"Fees_focusLine__3bHwg"};